import { Box, Tooltip } from '@mui/material'
import { C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Zap } from 'lucide-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { TaskTypeStyles } from './styles'

type EmergencyAccessTaskIconProps = {
    variant?: 'icon-only' | 'contained'
}

export const EmergencyAccessTaskIcon: React.FC<EmergencyAccessTaskIconProps> = ({ variant = 'icon-only' }) => {
    const intl = useIntl()

    return (
        <Tooltip
            title={<FormattedMessage id="task_type_emergency_access" defaultMessage="Emergency access requested" />}
            placement="top"
        >
            {variant === 'contained'
                ? <Box>
                    <C1IconButton
                        component="div"
                        size="small"
                        aria-label={intl.formatMessage({ id: 'task_type_emergency_access', defaultMessage: 'Emergency access requested' })}
                        sx={{
                            backgroundColor: 'warning.light',
                            pointerEvents: 'none',
                        }}
                    >
                        <C1Icon icon={Zap} sx={{ color: 'warning.contrastText' }} />
                    </C1IconButton>
                </Box>
                : <C1Icon icon={Zap} sx={TaskTypeStyles.emergencyAccessIcon} size="sm" />}
        </Tooltip>
    )
}
